webpackJsonp([256966496389845],{

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(278);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var className = props.className,
	      elementRef = props.elementRef,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      onBlur = props.onBlur,
	      onReady = props.onReady,
	      options = _objectWithoutProperties(props, ['className', 'elementRef', 'onChange', 'onFocus', 'onBlur', 'onReady']);
	
	  return options;
	};
	
	var Element = function Element(type) {
	  var _class, _temp;
	
	  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	      _this.handleRef = function (ref) {
	        _this._ref = ref;
	      };
	
	      var options = _extractOptions(_this.props);
	
	      // Stripe.js browser-only check
	      if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	        _this._element = _this.context.elements.create(type, options);
	        _this._setupEventListeners();
	      }
	
	      _this._options = options;
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._element.mount(this._ref);
	        if (hocOptions.sourceType) {
	          this.context.registerElement(hocOptions.sourceType, this._element);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var options = _extractOptions(nextProps);
	        if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	          this._options = options;
	          this._element.update(options);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._element.destroy();
	        this.context.unregisterElement(this._element);
	      }
	    }, {
	      key: '_setupEventListeners',
	      value: function _setupEventListeners() {
	        var _this2 = this;
	
	        this._element.on('ready', function () {
	          _this2.props.elementRef(_this2._element);
	          _this2.props.onReady();
	        });
	
	        this._element.on('change', function (change) {
	          _this2.props.onChange(change);
	        });
	
	        this._element.on('blur', function () {
	          var _props;
	
	          return (_props = _this2.props).onBlur.apply(_props, arguments);
	        });
	        this._element.on('focus', function () {
	          var _props2;
	
	          return (_props2 = _this2.props).onFocus.apply(_props2, arguments);
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement('div', { className: this.props.className, ref: this.handleRef });
	      }
	    }]);
	
	    return _class;
	  }(_react2.default.Component), _class.propTypes = {
	    className: _propTypes2.default.string,
	    elementRef: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onReady: _propTypes2.default.func
	  }, _class.defaultProps = {
	    className: '',
	    elementRef: noop,
	    onChange: noop,
	    onBlur: noop,
	    onFocus: noop,
	    onReady: noop
	  }, _class.contextTypes = {
	    elements: _propTypes2.default.object,
	    registerElement: _propTypes2.default.func.isRequired,
	    unregisterElement: _propTypes2.default.func.isRequired
	  }, _temp;
	};
	
	exports.default = Element;

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Elements = function (_React$Component) {
	  _inherits(Elements, _React$Component);
	
	  function Elements(props, context) {
	    _classCallCheck(this, Elements);
	
	    var _this = _possibleConstructorReturn(this, (Elements.__proto__ || Object.getPrototypeOf(Elements)).call(this, props, context));
	
	    _this.handleRegisterElement = function (type, element) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [{ type: type, element: element }])
	        };
	      });
	    };
	
	    _this.handleUnregisterElement = function (el) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: prevState.registeredElements.filter(function (_ref) {
	            var element = _ref.element;
	            return element !== el;
	          })
	        };
	      });
	    };
	
	    var _this$props = _this.props,
	        children = _this$props.children,
	        options = _objectWithoutProperties(_this$props, ['children']);
	
	    // Stripe.js browser-only check
	
	
	    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	      _this._elements = _this.context.stripe.elements(options);
	    }
	
	    _this.state = {
	      registeredElements: []
	    };
	    return _this;
	  }
	
	  _createClass(Elements, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        elements: this._elements,
	        registerElement: this.handleRegisterElement,
	        unregisterElement: this.handleUnregisterElement,
	        registeredElements: this.state.registeredElements
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.Children.only(this.props.children);
	    }
	  }]);
	
	  return Elements;
	}(_react2.default.Component);
	
	Elements.childContextTypes = {
	  elements: _propTypes2.default.object,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired,
	  registeredElements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    type: _propTypes2.default.string.isRequired,
	    element: _propTypes2.default.object.isRequired
	  })).isRequired
	};
	Elements.contextTypes = {
	  stripe: _propTypes2.default.object
	};
	Elements.defaultProps = {
	  children: null
	};
	exports.default = Elements;

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(278);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var className = props.className,
	      elementRef = props.elementRef,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onReady = props.onReady,
	      paymentRequest = props.paymentRequest,
	      options = _objectWithoutProperties(props, ['className', 'elementRef', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);
	
	  return options;
	};
	
	var PaymentRequestButtonElement = function (_React$Component) {
	  _inherits(PaymentRequestButtonElement, _React$Component);
	
	  function PaymentRequestButtonElement(props, context) {
	    _classCallCheck(this, PaymentRequestButtonElement);
	
	    var _this = _possibleConstructorReturn(this, (PaymentRequestButtonElement.__proto__ || Object.getPrototypeOf(PaymentRequestButtonElement)).call(this, props, context));
	
	    _this.handleRef = function (ref) {
	      _this._ref = ref;
	    };
	
	    var options = _extractOptions(props);
	    _this._element = _this.context.elements.create('paymentRequestButton', _extends({
	      paymentRequest: props.paymentRequest
	    }, options));
	    _this._options = options;
	    _this._element.on('ready', function () {
	      _this.props.elementRef(_this._element);
	      _this.props.onReady();
	    });
	    _this._element.on('focus', function () {
	      var _this$props;
	
	      return (_this$props = _this.props).onFocus.apply(_this$props, arguments);
	    });
	    _this._element.on('click', function () {
	      var _this$props2;
	
	      return (_this$props2 = _this.props).onClick.apply(_this$props2, arguments);
	    });
	    _this._element.on('blur', function () {
	      var _this$props3;
	
	      return (_this$props3 = _this.props).onBlur.apply(_this$props3, arguments);
	    });
	    return _this;
	  }
	
	  _createClass(PaymentRequestButtonElement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._element.mount(this._ref);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.paymentRequest !== nextProps.paymentRequest) {
	        console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
	      }
	      var options = _extractOptions(nextProps);
	      if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	        this._options = options;
	        this._element.update(options);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._element.destroy();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: this.props.className, ref: this.handleRef });
	    }
	  }]);
	
	  return PaymentRequestButtonElement;
	}(_react2.default.Component);
	
	PaymentRequestButtonElement.propTypes = {
	  className: _propTypes2.default.string,
	  elementRef: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  paymentRequest: _propTypes2.default.shape({
	    canMakePayment: _propTypes2.default.func.isRequired,
	    on: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	PaymentRequestButtonElement.defaultProps = {
	  className: '',
	  elementRef: noop,
	  onBlur: noop,
	  onClick: noop,
	  onFocus: noop,
	  onReady: noop
	};
	PaymentRequestButtonElement.contextTypes = {
	  elements: _propTypes2.default.object,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired
	};
	exports.default = PaymentRequestButtonElement;

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props));
	
	    var _this$props = _this.props,
	        apiKey = _this$props.apiKey,
	        children = _this$props.children,
	        options = _objectWithoutProperties(_this$props, ['apiKey', 'children']);
	
	    // Stripe.js browser-only check
	
	
	    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	      if (!window.Stripe) {
	        throw new Error('Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements.');
	      }
	
	      /**
	       * Note that this is not meant to be a generic memoization solution.
	       * This is specifically a solution for `StripeProvider`s being initialized
	       * and destroyed regularly (with the same set of props) when users only
	       * use `StripeProvider` for the subtree that contains their checkout form.
	       */
	      window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
	      var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);
	      _this._stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
	      window.Stripe.__cachedInstances[cacheKey] = _this._stripe;
	
	      _this._didWarn = false;
	    }
	    return _this;
	  }
	  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
	
	
	  _createClass(Provider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        stripe: this._stripe
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Stripe.js browser-only check
	      if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	        if (!this._didWarn && this.props.apiKey !== nextProps.apiKey && window.console && window.console.error) {
	          this._didWarn = true;
	          // eslint-disable-next-line no-console
	          console.error('StripeProvider does not support changing the apiKey parameter.');
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.Children.only(this.props.children);
	    }
	  }]);
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.propTypes = {
	  apiKey: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node
	};
	Provider.childContextTypes = {
	  stripe: _propTypes2.default.object
	};
	Provider.defaultProps = {
	  children: null
	};
	exports.default = Provider;

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
	// not sure if we need to do the same.
	var inject = function inject(WrappedComponent) {
	  var _class, _temp;
	
	  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _componentOptions$wit = componentOptions.withRef,
	      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;
	
	
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      if (!context || !context.registeredElements) {
	        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
	      }
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	      _this.requireElement = function (specifiedType) {
	        var element = _this.findElement(specifiedType);
	        if (element) {
	          return element;
	        } else {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        }
	      };
	
	      _this.findElement = function (specifiedType) {
	        var allElements = _this.context.registeredElements || [];
	        var matchingElements = specifiedType === 'auto' ? allElements : allElements.filter(function (_ref) {
	          var type = _ref.type;
	          return type === specifiedType;
	        });
	
	        if (matchingElements.length === 1) {
	          return matchingElements[0].element;
	        } else if (matchingElements.length > 1) {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        } else {
	          return null;
	        }
	      };
	
	      _this.wrappedCreateToken = function () {
	        var typeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (typeOrOptions && (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) === 'object') {
	          var type = typeOrOptions.type,
	              rest = _objectWithoutProperties(typeOrOptions, ['type']);
	
	          var specifiedType = typeof type === 'string' ? type : 'auto';
	          var element = _this.requireElement(specifiedType);
	          return _this.context.stripe.createToken(element, rest);
	        } else if (typeof typeOrOptions === 'string') {
	          return _this.context.stripe.createToken(typeOrOptions, options);
	        } else {
	          throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) + '.');
	        }
	      };
	
	      _this.wrappedCreateSource = function () {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	          var type = options.type,
	              rest = _objectWithoutProperties(options, ['type']); // eslint-disable-line no-unused-vars
	
	
	          var specifiedType = typeof type === 'string' ? type : 'auto';
	          var element = _this.findElement(specifiedType);
	          if (element) {
	            return _this.context.stripe.createSource(element, rest);
	          } else if (specifiedType !== 'auto') {
	            return _this.context.stripe.createSource(options);
	          } else {
	            throw new Error('You did not specify the type of Source to create.\n          We also could not find any Elements in the current context.');
	          }
	        } else {
	          throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
	        }
	      };
	
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        if (!withRef) {
	          throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
	        }
	        return this.wrappedInstance;
	      }
	    }, {
	      key: 'stripeProps',
	      value: function stripeProps() {
	        return _extends({}, this.context.stripe, {
	          // These are the only functions that take elements.
	          createToken: this.wrappedCreateToken,
	          createSource: this.wrappedCreateSource
	        });
	      }
	      // Require that exactly one Element is found.
	
	      // Finds the element by the specified type. Throws if multiple Elements match.
	
	
	      // createToken has a bit of an unusual method signature for legacy reasons
	      // -- we're allowed to pass in the token type OR the element as the first parameter,
	      // so we need to check if we're passing in a string as the first parameter and
	      // just pass through the options if that's the case.
	
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	          stripe: this.stripeProps(),
	          ref: withRef ? function (c) {
	            _this2.wrappedInstance = c;
	          } : null
	        }));
	      }
	    }]);
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = {
	    stripe: _propTypes2.default.object.isRequired,
	    registeredElements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      element: _propTypes2.default.object.isRequired,
	      type: _propTypes2.default.string.isRequired
	    }))
	  }, _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
	};
	
	exports.default = inject;

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentRequestButtonElement = exports.PostalCodeElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;
	
	var _Provider = __webpack_require__(660);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _inject = __webpack_require__(661);
	
	var _inject2 = _interopRequireDefault(_inject);
	
	var _Elements = __webpack_require__(658);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Element = __webpack_require__(657);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _PaymentRequestButtonElement = __webpack_require__(659);
	
	var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardElement = (0, _Element2.default)('card', { sourceType: 'card' });
	
	var CardNumberElement = (0, _Element2.default)('cardNumber', { sourceType: 'card' });
	var CardExpiryElement = (0, _Element2.default)('cardExpiry');
	var CardCVCElement = (0, _Element2.default)('cardCvc');
	var PostalCodeElement = (0, _Element2.default)('postalCode');
	
	exports.StripeProvider = _Provider2.default;
	exports.injectStripe = _inject2.default;
	exports.Elements = _Elements2.default;
	exports.CardElement = CardElement;
	exports.CardNumberElement = CardNumberElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardCVCElement = CardCVCElement;
	exports.PostalCodeElement = PostalCodeElement;
	exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shallowEqual = function shallowEqual(a, b) {
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  return keysA.length === keysB.length && keysA.every(function (key) {
	    return b.hasOwnProperty(key) && b[key] === a[key];
	  });
	};
	
	exports.default = shallowEqual;

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactStripeElementsUniversal = __webpack_require__(662);
	
	var _theme = __webpack_require__(30);
	
	var _styleguide = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentsPage = function (_React$Component) {
	  _inherits(PaymentsPage, _React$Component);
	
	  function PaymentsPage() {
	    _classCallCheck(this, PaymentsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PaymentsPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactStripeElementsUniversal.StripeProvider,
	      { apiKey: ("pk_test_7uNJeh01c1FkSilWUwi5NzcB") },
	      _react2.default.createElement(
	        _styleguide.ContentRow,
	        null,
	        _react2.default.createElement(
	          _reactStripeElementsUniversal.Elements,
	          null,
	          _react2.default.createElement(CardForm, { fontSize: 16 })
	        )
	      )
	    );
	  };
	
	  return PaymentsPage;
	}(_react2.default.Component);
	
	exports.default = PaymentsPage;
	
	var CardForm = (0, _reactStripeElementsUniversal.injectStripe)(_class = function (_React$Component2) {
	  _inherits(CardForm, _React$Component2);
	
	  function CardForm() {
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, CardForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.handleSubmit = function (ev) {
	      ev.preventDefault();
	      _this2.props.stripe.createToken().then(function (payload) {
	        return console.log('[token]', payload);
	      });
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  CardForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      Form,
	      { onSubmit: this.handleSubmit },
	      _react2.default.createElement(
	        Label,
	        null,
	        'Card details',
	        _react2.default.createElement(_reactStripeElementsUniversal.CardElement
	        // onBlur={handleBlur}
	        // onChange={handleChange}
	        // onFocus={handleFocus}
	        // onReady={handleReady}
	        , createOptions(this.props.fontSize))
	      ),
	      _react2.default.createElement(
	        Button,
	        null,
	        'Subscribe'
	      )
	    );
	  };
	
	  return CardForm;
	}(_react2.default.Component)) || _class;
	
	var createOptions = function createOptions(fontSize) {
	  return {
	    style: {
	      base: {
	        fontSize: fontSize,
	        color: '#424770',
	        letterSpacing: '0.025em',
	        fontFamily: 'Source Code Pro, monospace',
	        '::placeholder': {
	          color: '#aab7c4'
	        }
	      },
	      invalid: {
	        color: '#9e2146'
	      }
	    }
	  };
	};
	
	var Form = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'pay__Form'
	})(['padding-bottom:2.5rem;margin-bottom:2.5rem;box-shadow:0 .1875rem 0 #e6ebf1;max-width:24rem;margin-left:auto;margin-right:auto;']);
	var Label = /*#__PURE__*/_styledComponents2.default.label.withConfig({
	  displayName: 'pay__Label'
	})(['color:#6b7c93;font-weight:500;letter-spacing:0.025em;']);
	var Email = /*#__PURE__*/_styledComponents2.default.input.attrs({ type: 'text', placeholder: 'tom@jerry.com' }).withConfig({
	  displayName: 'pay__Email'
	})(['color:\'#424770\';font-size:1.5rem;line-height:2rem;letter-spacing:\'0.025em\';::placeholder{color:#aab7c4;}display:block;margin:.625rem 0 1.25rem 0;max-width:30rem;padding:.625rem .875rem;box-shadow:rgba(50,50,93,0.14902) 0 .0625rem .1875rem,rgba(0,0,0,0.0196078) 0 .0625rem 0;border-radius:.25rem;background:white;transition:all 150ms ease;&:hover{', ';box-shadow:rgba(50,50,93,0.109804) 0 .25rem .375rem,rgba(0,0,0,0.0784314) 0 .0625rem .1875rem;transition:all 150ms ease;}&:focus{', ';box-shadow:0 .4375rem .875rem rgba(50,50,93,0.1),0 .1875rem .375rem rgba(0,0,0,0.08);transition:all 150ms ease;}'], '' /* box-shadow:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     rgba(50, 50, 93, 0.109804) 0 .125rem .0625rem,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     rgba(0, 0, 0, 0.0784314) 0 0 .0625rem
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ; */, '' /* box-shadow:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              rgba(50, 50, 93, 0.109804) 0 .25rem .375rem,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              rgba(0, 0, 0, 0.0784314) 0 .0625rem .1875rem
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              ; */);
	
	var Button = /*#__PURE__*/_styledComponents2.default.button.withConfig({
	  displayName: 'pay__Button'
	})(['white-space:nowrap;border:0;outline:0;display:inline-block;height:2.5rem;line-height:2.5rem;padding:0 .875rem;box-shadow:0 .25rem .375rem rgba(50,50,93,0.11),0 .0625rem .1875rem rgba(0,0,0,0.08);color:#fff;border-radius:.25rem;font-size:.9375rem;font-weight:600;text-transform:uppercase;letter-spacing:0.025em;background-color:', ';text-decoration:none;transition:all 150ms ease;margin-top:0.75rem;&:hover{color:#fff;cursor:pointer;background-color:#7795f8;transform:translateY(-.0625rem);box-shadow:0 .4375rem .875rem rgba(50,50,93,0.1),0 .1875rem .375rem rgba(0,0,0,0.08);}&:active{color:#fff;cursor:pointer;background-color:', ';transform:translateY(.0625rem);box-shadow:0 .1875rem .3125rem rgba(50,50,93,0.1),0 0 .0625rem rgba(0,0,0,0.08);}'], _theme.colors.indigo[6], _theme.colors.indigo[8]);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pay-js-36ec99353dba3641d9e8.js